import { routes } from '@config/index';
import { api } from '../api/api';
export function submitFeedback(data) {
    //   eslint-disable-next-line
    return api.post(routes.apiEndpoints.feedback(), JSON.stringify(data));
}
